import { useAppSelector } from '@/redux/store'
import { Platform } from 'react-native'

export function useIsAppReviewMode(): boolean {
  const appReviewMode = useAppSelector(state => state.session.appReviewMode)
  return Platform.OS === 'ios' && appReviewMode
}
